export function cropImage(originalImage, cropWidthPixel, cropHeightPixel) {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = (event) => {
            const img = new Image();
            img.src = event.target.result;
            img.onload = () => {
                const originalWidth = img.width;
                const originalHeight = img.height;
                const cropWidth = cropWidthPixel;
                const cropHeight = cropHeightPixel;
                let factorScale = 1;
                const resizeNeeded = originalWidth < cropWidth || originalHeight < cropHeight;
                if (resizeNeeded) {
                    const scaleX = cropWidth / originalWidth;
                    const scaleY = cropHeight / originalHeight;
                    factorScale = Math.max(scaleX, scaleY);
                }
                const resizedImage = _resizeImage(img, factorScale);
                const cropCanvas = _centralizedCropCanvasElement(resizedImage, cropWidth, cropHeight);
                cropCanvas.toBlob(blob => {
                    if (blob) {
                        const croppedFile = new File([blob], `cropped_${originalImage.name}`, {
                            type: originalImage.type,
                        });
                        resolve(croppedFile);
                    }
                    else {
                        reject(new Error('Could not create Blob from canvas'));
                    }
                }, originalImage.type, 1.0);
            };
            img.onerror = () => {
                reject(new Error('Failed to load image'));
            };
        };
        reader.onerror = () => {
            reject(new Error('Failed to read original file'));
        };
        reader.readAsDataURL(originalImage);
    });
}
function _resizeImage(img, scaleFactor) {
    const canvas = document.createElement('canvas');
    const ctx = canvas.getContext('2d');
    if (!ctx) {
        throw new Error('Failed to get 2D context');
    }
    const newWidth = img.width * scaleFactor;
    const newHeight = img.height * scaleFactor;
    canvas.width = newWidth;
    canvas.height = newHeight;
    ctx.drawImage(img, 0, 0, newWidth, newHeight);
    return canvas;
}
function _centralizedCropCanvasElement(canvasElement, cropWidth, cropHeight) {
    const canvas = document.createElement('canvas');
    const ctx = canvas.getContext('2d');
    if (!ctx) {
        throw new Error('Failed to get 2D context');
    }
    canvas.width = cropWidth;
    canvas.height = cropHeight;
    const centerX = canvasElement.width / 2;
    const centerY = canvasElement.height / 2;
    const cropX = Math.max(0, centerX - cropWidth / 2);
    const cropY = Math.max(0, centerY - cropHeight / 2);
    const safeCropWidth = Math.min(cropWidth, canvasElement.width - cropX);
    const safeCropHeight = Math.min(cropHeight, canvasElement.height - cropY);
    const destX = (cropWidth - safeCropWidth) / 2;
    const destY = (cropHeight - safeCropHeight) / 2;
    ctx.drawImage(canvasElement, cropX, cropY, safeCropWidth, safeCropHeight, destX, destY, safeCropWidth, safeCropHeight);
    return canvas;
}
